var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM12.9524 9.27631C13.3174 8.92042 13.3248 8.336 12.9689 7.97099C12.613 7.60597 12.0286 7.59857 11.6636 7.95446L9.46776 10.0954L8.33701 8.99292C7.97199 8.63703 7.38758 8.64443 7.03169 9.00945C6.67579 9.37446 6.68319 9.95888 7.04821 10.3148L9.46776 12.6738L12.9524 9.27631Z",
    fill: "#0071BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGusIcon);
export default __webpack_public_path__ + "static/media/gusIcon.cfe65599.svg";
export { ForwardRef as ReactComponent };